<!-- 产品-产品列表 -->
<template>
  <div class="md-layout">
    <!-- 设备列表 + 查询表单 -->
    <template v-if="!selected.pk" >
      <!-- 卡片一-筛选查询用表单 -->
      <div class="md-layout-item md-size-100">
        <md-card>
          <!-- 卡片-主体 -->
          <md-card-content>
            <div class="md-layout card-form">
              <!-- 表单-选择框-查询类型 {1: 名称, 2: PK 值} -->
              <div class="md-layout-item md-size-15 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <md-select v-model="searchForm.searchType">
                    <md-option :value="1">{{$I18n('name')}}</md-option>
                    <md-option :value="2">PK</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-输入框-查询的值 -->
              <div class="md-layout-item md-size-15 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <label v-if="searchForm.searchType === 1">{{$I18n('name')}}</label>
                  <label v-if="searchForm.searchType === 2">PK</label>
                  <md-input v-model="searchForm.searchValue"/>
                </md-field>
              </div>
              <!-- 表单-选择框-查询的公司(默认用户公司) -->
              <div class="md-layout-item md-size-15 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <label>{{$I18n('company')}}</label>
                  <md-select v-model="searchForm.comp_id">
                    <md-option value="__ALL__">{{$I18n("all")}}</md-option>
                    <md-option v-for="item in compData" :key="item.comp_id" :value="item.comp_id">{{item.comp_name}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-按钮 {只在小屏幕下展示} -->
              <div v-if="$root.state.mobile" class="md-layout-item md-xsmall-size-50 no-right-padding">
                <md-button @click="form_changeSearchData" class="md-just-icon left-icon md-info mobile-from-button">
                  <md-icon>search</md-icon>
                </md-button>
                <md-button @click="addProduct" class="md-just-icon left-icon md-info mobile-from-button">
                  <md-icon v-if="$root.state.mobile">add</md-icon>
                </md-button>
              </div>
              <!-- 表单-按钮 {只在大屏幕下展示} -->
              <div v-else class="md-layout-item">
                <md-button @click="form_changeSearchData" class= "left-icon md-info">
                  <md-icon>search</md-icon>
                  {{$I18n("search")}}
                </md-button>
                <md-button @click="addProduct" class="left-icon md-info">
                  <md-icon>add</md-icon>
                  {{$I18n("add")}}
                </md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <!-- 卡片组-设备列表 -->
      <div v-for="item in tableInitData" :key="item.id" @click="selecedItem(item)" class="md-layout-item md-size-25 md-xsmall-size-100">
        <md-card>
          <!-- 卡片主体-设备信息 -->
          <md-card-content>
            <div>
              <!-- 设备图片 -->
              <div class="product-card-img">
                <img :src="item.img"/>
                <div class="shadow" />
              </div>
              <!-- 文字说明 -->
              <div class="product-card-main">
                <!-- 设备名字 -->
                <p class="weight-font">{{item.name}}</p>
                <!-- 节点类型{1:多通道, 2:设备} -->
                <p class="product-card-p" :style="{'margin-right':'8px'}">
                  {{item.node_type == 2 ?$I18n("device") :$I18n("gateway") }}
                </p>
                <!-- 类型名称 -->
                <p class="product-card-p">{{$router.history.current.query.lang == 'en' ?item.category_name :item.category_cn_name}}</p>
                <!-- PK值 -->
                <p :style="{'line-height':'21px','position':'relative'}">
                  PK: {{item.pk}}
                  <span>
                    <md-button style="position: absolute;top: -16px;" class="md-just-icon md-simple" @click.stop="() => {copy(item.pk)}">
                      <md-icon>content_copy</md-icon>
                    </md-button>
                  </span>
                </p>
                <!-- 创建时间 -->
                <div :style="{'line-height': '22px'}">
                  {{$I18n("created_thing_time")}}: {{item.create_time.split(" ")[0]}}
                  <div class="right-button">
                    <!-- 设置按钮 -->
                    <md-button @click.stop="editProduct(item)" class="md-just-icon md-simple md-info"><md-icon>settings</md-icon></md-button>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <!-- 卡片-列表-翻页 -->
      <div class="md-layout-item md-size-100">
        <md-card :style="{'background-color':'unset','box-shadow':'none'}">
          <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
        </md-card>
      </div>
    </template>
    <!-- 详细表格数据 -->
    <div v-if="!!selected.pk" class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-头部 -->
        <card-head :icon="icon" :title="selected.name">
          <!-- 返回设备列表 -->
          <md-button @click="selected = {}" class="md-primary md-sm md-info right-button md-just-icon md-round">
            <md-icon>reply</md-icon>
          </md-button>
          <!-- PK值 -->
          <div class="md-subhead" style="display: inline-block;">PK: {{selected.pk}}</div>
        </card-head>
        <!-- 卡片-主体 {大屏幕模式} -->
        <md-card-content :style="{'display':'flex','flex-wrap':'wrap'}">
          <!-- 卡片-主体-选择表格栏 -->
          <div class="md-layout-item md-size-100 line"></div>
          <!-- 左侧栏 -->
          <div class="scroll md-layout-item md-size-20 md-small-size-30 md-xsmall-size-100" :style="{'border-right':'1px solid rgba(180, 180, 180, 0.3)','margin-top':'20px'}">
            <div class="main-box">
              <template v-for="(firItem, firIndex) in menusList">
                <div v-if="firIndex > 0" :key="firIndex" class="line"></div>
                <div v-for="secItem in firItem" :key="secItem" @click="() => {active = secItem}" :class="{'selected': active == secItem }" class="menu-item-box">
                  {{secItem}}
                </div>
              </template>
            </div>
          </div>
          <!-- 右侧 -->
          <div class="scroll md-layout-item md-size-80 md-small-size-70 md-xsmall-size-100" 
            :style="{'margin-top':'20px','max-height':'calc( 100vh - 192px - 64px - 51px );'}"
          >
            <!-- 卡片-主体-表格-当前版本选择 -->
            <div v-if="active === $I18n('fir_update')">
              <!-- 表单 -->
              <div class="md-layout card-form">
                <!-- 表单-选择框-查询类型 {1: 名称, 2: PK 值} -->
                <div class="md-layout-item md-size-15 md-xsmall-size-50 left-layout-item">
                  <md-field>
                    <label>{{$I18n('state')}}</label>
                    <md-select v-model="fir_searchForm.state">
                      <md-option :value="0">{{$I18n('all')}}</md-option>
                      <md-option :value="1">{{$I18n('open')}}</md-option>
                      <md-option :value="2">{{$I18n('close')}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- 表单-输入框-查询的值 -->
                <div class="md-layout-item md-size-15 md-xsmall-size-50 left-layout-item">
                  <md-field>
                    <label>{{$I18n('tag')}}</label>
                    <md-input v-model="fir_searchForm.tag"/>
                  </md-field>
                </div>
                <div  class="md-layout-item">
                  <md-button @click="form_fir_changeSearchData" class= "left-icon md-info">
                    <md-icon>search</md-icon>
                    {{$I18n("search")}}
                  </md-button>
                  <md-button @click="form_addNewVersion" class="left-icon md-info">
                    <md-icon>add</md-icon>
                    {{$I18n("add")}}
                  </md-button>
                </div>
              </div>
              <!-- 卡片-主体-表格-版本
                版本号
                更新方式 {1: 强制, 2: 用户自愿}
                状态 {1: 开启, 2: 关闭 }
                自定义key
                关联类型 {1: UID, 2: MAC, 0: 无}
                关联数据 {对应类型的数据}
                设备批次ID 
                等级 {1: 低, 2: 中, 3: 高}
                创建时间
                操作按钮 [修改该版本, 删除该版本]
               -->
              <md-table v-if="ver_tableData.length > 0" :style="{'textAlign':'center'}"> 
                <md-table-row>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('ver_code')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('force_update')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('state')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('custom_key')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('link_type')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('link_id')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('batch_id')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('level')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center'}">{{$I18n('created_thing_time')}}</md-table-head>
                  <md-table-head :style="{'text-align':'center','min-width':'150px'}">{{$I18n('operate')}}</md-table-head>
                </md-table-row>
                <md-table-row v-for="(item, index) in ver_tableData" :key="index">
                  <md-table-cell>{{ item.ver_num > 0 ?`${item.ver}(${item.ver_num})` :item.ver }}</md-table-cell>
                  <md-table-cell>{{ item.type_name }}</md-table-cell>
                  <md-table-cell>{{ item.state_name }}</md-table-cell>
                  <md-table-cell>{{ item.oem }}</md-table-cell>
                  <md-table-cell>{{ item.link_type_name }}</md-table-cell>
                  <md-table-cell>{{ item.link_id }}</md-table-cell>
                  <md-table-cell>{{ item.batch_id }}</md-table-cell>
                  <md-table-cell>{{ item.level_name }}</md-table-cell>
                  <md-table-cell>{{ item.create_thing_time }}</md-table-cell>
                  <md-table-cell class="button-box" :style="{'min-width':'150px'}">
                    <md-button @click="table_editVersion(item)" @click.stop class="md-just-icon md-round md-info left-icon">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button @click="table_delVersion(item)" @click.stop class="md-just-icon md-round md-danger md-info">
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <!-- 用于没有数据的时候的展示 -->
              <md-table v-else v-model="ver_tableData">
                <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
                  <md-table-cell :md-label="$I18n('menu_name')">{{item.state}}</md-table-cell>
                </md-table-row>
                <md-table-empty-state slot="md-table-empty-state">
                  {{$I18n("none_data")}}
                </md-table-empty-state>
              </md-table>
              <table-page :total="ver_count" :pageSize="pageSize" v-model="ver_pageNo"/>
            </div>
            <!-- 卡片-主体-绑定商品选择 ./Product/Product/ShopConfig.vue -->
            <div v-if="active === $I18n('setting_product')">
              <shop-config :show="active === $I18n('setting_product')" :pk="selected.pk" :comps="compData"/>
            </div>
            <!-- 卡片-主体-领取商品配置 ./Product/Product/ShopGiveConfig.vue -->
            <div v-if="active === $I18n('give_shop_config')">
              <shop-give-config :show="active === $I18n('give_shop_config')" :pk="selected.pk" :comps="compData"/>
            </div>
            <!-- 卡片-主体-赠送商品配置 ./Product/Product/ShopGetConfig.vue -->
            <div v-if="active === $I18n('get_shop_config')">
              <shop-get-config :show="active === $I18n('get_shop_config')" :pk="selected.pk" :comps="compData"/>
            </div>

            <!-- 卡片-主体-设备详情 ./Product/Product/Device.vue -->
            <div v-if="active === $I18n('device_info')">
              <device :show="active === $I18n('device_info')" :pk="selected.pk" :comps="compData"/>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "openModalType!=='sub-delete'"
      @submit= "modal_submit"
      @close = "modal_classicModalHide"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='sub-delete'">{{$I18n("check_delete", modalSubData.Form.ver)}}</div>
        <!-- 修改/添加表单弹窗 -->
        <div v-else-if="openModalType==='sub-add'|| openModalType === 'sub-edit'" class="md-layout">
          <common-form-item 
            class="md-layout-item md-size-50"
            v-for="item in form_modalSubData" 
            v-model="modalSubData.Form[item.keys]" 
            :error="modalSubData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
          <!-- 表单-按钮-添加新的详情 -->
          <div class="md-layout-item md-size-50" :style="{'text-align':'left','padding-left':'28px'}">
            <md-button :style="{'text-align':'left','margin-top':'50px'}" @click="modal_addNewVersionDetail" class=" md-info">{{$I18n("add_detail_info")}}</md-button>
          </div>
          <input :ref="'url_file_input_'" style="display: none;" type="file" @change="onFileChange_url"/>
          <!-- 表单-详情部分 -->
          <div class="md-layout-item md-size-100" v-for="(item, index) in modalSubData.Form.details" :key="index" >
            <md-card>
              <md-card-content>
                <div class="md-layout">
                  <!-- 表单-输入栏-标题 -->
                  <div class="md-layout-item md-layout md-size-100">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'text-align':'left', 'padding-left': '12px'}">
                      {{$I18n("oat_title")}}<i style="color: red;">*</i>:
                    </label>
                    <div class="md-layout-item md-size-100">
                      <md-field>
                        <md-input v-model="item.title"/>
                      </md-field>
                    </div>
                  </div>
                  <div class="md-layout-item md-layout md-size-50">
                    <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left', 'padding-left': '12px'}">
                      {{$I18n("area_type")}}:
                    </label>

                    <div class="md-layout-item md-size-100 " style="position: relative;">
                      <md-field>
                        <!-- 可修改 -->
                        <md-select v-model="item.zone_type">
                          <md-option value="1">{{$I18n("continent")}}</md-option>
                          <md-option value="2">{{$I18n("zone")}}</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                  <!-- 表单-输入栏-地区 -->
                  <div class="md-layout-item md-layout md-size-50" v-if="item.zone_type == 1">
                    <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left', 'padding-left': '12px'}">
                      {{$I18n("continent")}}:
                    </label>

                    <div class="md-layout-item md-size-100 " style="position: relative;">
                      <md-field>
                        <!-- 可修改 -->
                        <md-select v-model="item.zone_continent">
                          <md-option value="ALL">{{$I18n("all")}}</md-option>
                          <md-option v-for="item in continentArray" :key="item.code" :value="item.code">{{
                            lang === "zh" ?item.cn_name :item.name
                          }}</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                  <!-- 表单-输入栏-地区 -->
                  <div class="md-layout-item md-layout md-size-50" v-if="item.zone_type == 2">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'text-align':'left', 'padding-left': '12px'}">
                      {{$I18n("zone")}}:
                    </label>

                    <div class="md-layout-item md-size-100 " style="position: relative;">
                      <div style="position:absolute; top:0; bottom: 0; left: 0; right: 0;z-index: 1;cursor: pointer;" @click="() => openSelectZone(index)"></div>
                      <md-field>
                        <!-- 可修改 -->
                        <md-select v-model="item.zone_zone">
                          <md-option value="ALL">{{$I18n("all")}}</md-option>
                          <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                            lang === "zh" ?item.cn_name :item.name
                          }}</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>
                  <!-- 表单-输入栏-URL -->
                  <div style="position: relative;" class="md-layout-item md-layout md-size-100">
                    <label class="md-layout-item md-size-100 md-form-label" :style="{'text-align':'left', 'padding-left': '12px'}">
                      {{$I18n("oat_url_2")}}<i style="color: red;">*</i>:
                    </label>
                    <div class="md-layout-item md-size-100 ">
                      <md-field>
                        <!-- 可修改 -->
                        <md-input v-model="item.url" style="margin-right: 45px;"/>
                      </md-field>
                    </div>
                    <md-button @click="() => clickInput_url(index)" style="position: absolute;top: 42px; right: 25px;" class="md-info md-round md-fileinput md-just-icon">
                      <md-icon>upload</md-icon>
                    </md-button>
                  </div>
                  <!-- 表单-富文本输入栏-详细说明 -->
                  <div class="md-layout-item md-layout md-size-100">
                    <md-button @click="item.showContent = !item.showContent" class="md-info">
                      {{item.showContent ?$I18n("hide") :$I18n("show")}}
                    </md-button>
                  </div>
                  <div class="md-layout-item md-layout md-size-100" v-if="item.showContent">
                    <label class="md-layout-item md-size-30 md-form-label" :style="{'text-align':'left', 'padding-left': '12px'}">
                      {{$I18n("oat_content")}}:
                    </label>
                    <div class="md-layout-item md-size-100 ">
                      <md-field >
                        <md-textarea v-model="item.content"></md-textarea>
                      </md-field>
                    </div>
                  </div>
                  <!-- 表单-按钮-删除该详情表单 -->
                  <div :style="{ 'position': 'absolute', 'right': '0', 'top': '-26px', }">
                    <md-button @click="modalSubData.Form.details.splice(index,1)" class="md-primary md-sm md-info right-button md-just-icon md-round">
                      <md-icon>close</md-icon>
                    </md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
        <div v-else class="md-layout">
          <template v-for="item in form_modalData">
            <common-form-item 
              :key="item.keys"
              v-if="item.dataType!=='attr'"
              v-model="modalData.Form[item.keys]" 
              :error="modalData.Error[item.keys]" 
              v-bind="item"
            >
              <div v-if="item.keys === 'img'" class="file-input">
                <!-- 默认图片 -->
                <div @click="clickInput" class="image-container" :style="{'box-shadow': 'none'}">
                  <img v-if="!imageRegular" :src="regularImg" />
                  <img v-else :src="imageRegular" />
                </div>
                <div>
                  <md-button class="md-info md-round md-fileinput" @click="clickInput">
                    <template v-if="!imageRegular">{{$I18n("upload_img")}}</template>
                    <template v-else>{{$I18n("upload_img")}}</template>
                  </md-button>
                </div>
              </div>
            </common-form-item>
            <common-form-item 
              :key="item.keys"
              v-if="item.dataType==='attr'"
              v-model="modalDataAttr.Form[item.keys]" 
              :error="modalDataAttr.Error[item.keys]" 
              v-bind="item"
            />
          </template>
          <input :style="{'display':'none'}" ref="file_input" type="file" @change="onFileChange" />
        </div>
      </template>
    </simple-modal>
    <zone-select-modal ref="zoneselect" @select="value => selectZone(value)"/>
  </div>
</template>
<script>
  // getInitComp
import { timestampToString, FormClass, } from "@/common/tools.js";
import ShopConfig from "./Product/ShopConfig.vue";
import ShopGiveConfig from "./Product/ShopGiveConfig.vue";
import ShopGetConfig from "./Product/ShopGetConfig.vue";
import Device from "./Product/Device.vue";
import ZoneSelectModal from "@/components/Common/ZoneSelectModal";
import {countryArray, continentArray} from "@/common/continent.js";

export default {
  components: {
    ShopConfig,
    ShopGiveConfig,
    ShopGetConfig,
    Device,
    ZoneSelectModal,
  },
  data() {
    return {
      upload_index: 0,
      fir_searchForm:{
        tag  :"",
        state:0,
      },
      fir_searchData:{
        tag  :"",
        state:0,
      },
      zone_select_index:0,
      countryArray,
      continentArray,

      lang : this.$router.history.current.query.lang,
      menusList : [
        (this.UserInfo.role_id < 10000 
          ?[
            this.$I18n("device_info"),
            this.$I18n("setting_product"),
            this.$I18n('give_shop_config'),
            this.$I18n('get_shop_config'),
            this.$I18n("fir_update")
          ] 
          : [
            this.$I18n("device_info"),
            this.$I18n("setting_product"),
            this.$I18n("fir_update")
          ]
        ),
      ],
      searchData : {   // 表格-查询范围
        name : "",
        pk : "",
        comp_id: "__ALL__",
      },
      productType: [], // 设备类型 (通过请求获取)
      searchForm : {   // API-查询范围
        searchType : 1,
        searchValue: "",
        comp_id: "__ALL__",
        // state : "0",
      },
      active : this.$I18n('device_info'), // 展示的内容 {fir_update: 固件版本, setting_product: 商品配置}
      useing_version : "",    // 表单-当前使用版本
      ver_tableInitData : [], // 表格-版本数据 (原始数据)
      ver_count  :0,          // 表格-版本数据总数
      ver_pageNo :0,          // 表格-版本数据当前页码
      selected : {},          // 表格-当前选择的设备

      imageRegular : "",      // 选择图片
      regularImg : "/img/image_placeholder.jpg", // 当前展示的图片

      // 表格相关
      icon  : "dns", // 表格-ICON
      title : this.$I18n("product_list"), // 表格-卡片标题
      tableInitData : [],                 // 表格-原始数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,   // 表格-每页数据数量
      currentPage : 1, // 表格-现在所处页数
      total : 0,       // 表格-数据总数
      // 弹窗相关
      openModal: false,   // 弹窗-是否打开
      modalTitle : "",    // 弹窗-标题
      openModalType : "", // 弹窗-弹窗类型

      modalData    : new FormClass({
        name     : {
          init : "",
          check: "required",
        },
        sync: 1,
        comp_id  : this.UserInfo.comp_id,
        category : 1,
        node_type: 1,
        img      : "",
        remark   : "",
        proto_type: "udp",
      }),
      modalDataAttr: new FormClass({
        live     : 2,
        oss_cfg  : 2,
        vendor_id: "1009",
        eventoss_cfg: 2,
        a_type : 1,
        f_ioss : 2,
        del_day: {
          init : 0,
          check: 'int',
        },
        lifecycle: {
          init: 1,
          check: value => {
            return value < 1 || value > 30
          }
        },
        alarm_inr: {
          init : 120,
          check:"int",
        },
        dk_limit :2,
      }),
      modalSubData : new FormClass({
        type : 1,
        state: 2,
        level: 1,
        link_type: 0,
        limit:"",
        count:"",
        tag  : {
          init: "",
          check:"required",
        },
        ver_num : {
          init: "",
          check:"int",
        },
        min_ver_num: {
          init: "",
          // check:"int",
        },
        max_ver_num: {
          init: "",
          // check:"int",
        },
        ver  : {
          init: "",
          check:"required",
        },
        oem  : {
          init: "",
          // check:"required",
        },
        batch_id : "",
        details:  () => {
          return [
            {
              size : "",
              lang : "en",
              title: "",
              url  : "",
              zone_type: "1",
              zone_zone: "ALL",
              zone_continent: "ALL",
              // zone : "ALL",
              content:"",
              inp_lang: "",
              showContent:false,
            }
          ]
        },
      }),
    };
  },
  mounted : function() {
    if(!this.UserInfo.comp_id){
      this.$api.userInfo({type: 1})
        .then(this.$Then(() => {
          return this.api_getComp().then(() => {
            // let init_comp = getInitComp(this.compData, res.data.comp_id);
            // this.searchForm.comp_id = init_comp;
            // this.searchData.comp_id = init_comp;
          })
        }))
        .then(() =>{
          this.api_getProductType();
          this.api_getPageData().then(() => {
            let id = this.$router.history.current.query.id;
            if(id){
              let product = this.tableInitData.filter(data => {
                return String(data.id) == String(id)
              })[0]
              if(product){
                this.editProduct(product)
              }
            }
          });
        })
        .catch(this.$Catch(""));
    } else {
      this.api_getComp().then(() => {
        // let init_comp = getInitComp(this.compData, this.UserInfo.comp_id);
        // this.searchForm.comp_id = init_comp;
        // this.searchData.comp_id = init_comp;
      })
      .then(() => {
        this.api_getProductType();
        this.api_getPageData().then(() => {
          let id = this.$router.history.current.query.id;
          if(id){
            let product = this.tableInitData.filter(data => {
              return String(data.id) == String(id)
            })[0]
            if(product){
              this.editProduct(product)
            }
          }
        });
      });
    }
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      if(this.selected.pk){
        this.api_getProductVer();
      }else{
        this.api_getPageData();
      }
    },
    selected () {
      if(this.selected.pk){
        this.api_getProductVer();
      } else {
        this.active = this.$I18n('device_info')
      }
    },
  },
  methods: {
    ...({ // 上传文件

      // (file发生变化)
      onFileChange_url ($event) {
        this.onFileSelected($event)
      },
      onFileSelected ({ target, dataTransfer }) {
        const files = target.files || dataTransfer.files;
        this.getFileName(files, target);
      },
      getFileName(files, target) {
        if (!files || files.length === 0) {
          return target.value.split('\\').pop()
        }
        if (files.length > 1) {
          return this.getMultipleName(files)
        }
        if (files.length === 1) {
          const uploadItem = this.modalSubData.Form.details[this.upload_index];
          const type = uploadItem.zone_type == 1 ?"region" :"zone";
          this.$api.uploadFile_PUT({
            file: files[0], 
            [type] : uploadItem[type == "region" ?"zone_continent" :"zone_zone"],
          })
            .then(this.$Then(res => {
              this.modalSubData.Form.details[this.upload_index].url = res.data.get_url;
              this.$refs.url_file_input_.value = "";
            }))
            .catch(this.$Catch(this.$I18n("get_error")))
          return files[0].name;
        }
        return null
      },
      clickInput_url(index){
        this.upload_index = index;
        this.$refs.url_file_input_.click();
      },
    }),

    openSelectZone(index){
      this.zone_select_index = index;
      this.$refs.zoneselect.open();
    },
    selectZone(zone){
      this.modalSubData.Form.details[this.zone_select_index].zone_zone = zone;
      this.$refs.zoneselect.close();
    },
    copy(value){
      document.execCommand("copy")
      let copyDOM = document.createElement("input")
      document.body.appendChild(copyDOM)
      copyDOM.value= value
      copyDOM.select()
      document.execCommand("copy")
      copyDOM.blur()
      document.body.removeChild(copyDOM)
    },
    form_fir_changeSearchData () {
      this.fir_searchData = {...this.fir_searchForm}
      this.ver_pageNo = 1;
      this.api_getProductVer();
    },
    form_changeSearchData () { // 表单-确认查询数据并重新查询
      this.searchData = {
        name : this.searchForm.searchType === 1 ?this.searchForm.searchValue :"",
        pk   : this.searchForm.searchType === 2 ?this.searchForm.searchValue :"",
        comp_id: this.searchForm.comp_id,
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
    changeLeftTabs(active){ // 详细界面-切换左侧菜单时的保险措施
      this.active = ""
      setTimeout(()=>{
        this.active = active;
      },100)
    },
    selecedItem(item){ // 表格-选择数据
      if(this.selected == item){
        this.selected = {};
      } else {
        this.selected = item;
      }
    },
    form_addNewVersion () { // 表格-添加新的版本
      this.$refs.modal.open();
      this.modalTitle = this.$I18n("add");
      this.openModalType = "sub-add";
      this.modalSubData.Reset();
    },
    table_editVersion (item) { // 表格-修改版本
      this.$refs.modal.open();
      this.modalTitle = this.$I18n("edit");
      this.openModalType = "sub-edit";
      this.modalSubData.Update({
        ver_num: "0",
        ...item,
        link_type : item.link_type ?item.link_type :0,
        details : item.details ?[...item.details.map(detail => {
          let inp_lang = "";
          if(!["en","zh-CN","zh-TW"].includes(detail.lang)){
            inp_lang = detail.lang;
          }
          return {
            ...detail,
            lang : inp_lang ?"other" :detail.lang,
            zone_zone: detail.zone_type == 2 ?detail.zone :"ALL",
            zone_continent: detail.zone_type == 1 ?detail.zone :"ALL",
            showContent: false,
            inp_lang,
          }
        })] :[],
      })
    },
    table_delVersion(item) { // 表格-删除版本
      this.$refs.modal.open();
      this.modalTitle = this.$I18n("edit");
      this.openModalType = "sub-delete";
      this.modalSubData.Update(item)
    },
    modal_addNewVersionDetail () { // 弹窗-表单-按钮-添加新的版本详情
      this.modalSubData.Form.details.push({
        lang : "en",
        title: "",
        url:"",
        content:"",
        zone_type: "1",
        zone_zone: "ALL",
        zone_continent: "ALL",
        showContent:false,
        inp_lang: "",
      })
    },
    api_getProductVer(){ // API-获取产品版本列表
      this.$api.getProductVer({ // api: /ota/product/ver/get
        ...this.fir_searchData,
        pk : this.selected.pk,
      })
        .then(this.$Then(res => {
          let useVer = res.data.filter(item => {
            return item.state === 1;
          })[0]
          if(useVer){
            this.useing_version = useVer.id;
          } else {
            this.useing_version = ""
          }
          this.ver_tableInitData = res.data;
          this.ver_count = res.data.length;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.useing_version = ""
          this.ver_tableInitData = [];
          this.ver_count = 0;
        }))
    },
    ...({
      onFileChange(e) { // 图片插件相关 {上传图片}
        let files = e.target.files || e.dataTransfer.files;
        if (!files  || !files.length) return;
        let reader = new FileReader();
        let vm = this;
        reader.onload = (e) => {
          vm.imageRegular = e.target.result;
        };

        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            this.modalData.Form.img = res.data;
            reader.readAsDataURL(files[0]);
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      },
      clickInput(){ // 图片插件-点击按钮 触发 img input
        this.$refs.file_input.click();
      },
    }),
    api_getProductType(){ // API-获取所有的商品类型
      this.$api.getProductType({ // api: /user/product/category/get
        parent_id: 0,
      })
        .then(this.$Then(res => {
          this.productType = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.productType = [];
        }))
    },
    api_getComp (){ // API-获取所有的公司
      //获取菜单
      return this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.compData = [];
        }))
    },
    api_getPageData(){ // API-获取页面数据
      // 云存储订单信息
      return this.$api.getProduct({ // api: /user/product/get
        ...this.searchData,
        comp_id: this.searchData.comp_id === "__ALL__" ?0  :this.searchData.comp_id,
        page_size: this.pageSize,
        page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    addProduct (){ // 表格-打开 添加新的商品 弹窗
      this.modalData.Reset();
      this.modalDataAttr.Reset();
      this.openModalType = "add"
      this.$refs.value =  "";
      this.imageRegular = "";
      this.modalTitle = this.$I18n("add");
      this.$refs.modal.open();
    },
    editProduct (item){ // 表格-打开 修改该商品 弹窗
      this.modalData.Update(item)
      this.modalDataAttr.Reset();

      if(isNaN(this.modalDataAttr.Form.vendor_id) || this.modalDataAttr.Form.vendor_id <= 0){
        this.modalDataAttr.Form.vendor_id = "1009";
      }
      if(this.modalData.Form.sync != 1 || this.modalData.Form.sync != 2){
        this.modalData.Form.sync = 1;
      }

      if(item.attr){
        let attrData = JSON.parse(item.attr);
        if(!attrData.a_type){
          attrData.a_type = 1
        }
        if(!attrData.f_ioss){
          attrData.f_ioss = 2
        }
        this.modalDataAttr.Update({
          eventoss_cfg: "2",
          ...this.modalDataAttr.Form,
          ...attrData,
        })
      }
      this.openModalType = "edit"
      this.$refs.value  = this.modalData.Form.img;
      this.imageRegular = this.modalData.Form.img;
      this.modalTitle   = this.$I18n("edit");
      this.$refs.modal.open();
      return  false
    },
    modal_classicModalHide () { // 弹窗-关闭弹窗
      if(this.selected.pk){
        this.api_getProductVer();
      } else {
        this.api_getPageData();
      }
      this.$refs.modal.close();
    },
    modal_submit () { // 弹窗-提交表单
      const attrsForm = {...this.modalDataAttr.Form};
      if(this.openModalType == 'add'){
        if(this.modalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"))
          return 
        }
        if(this.modalDataAttr.Check()){
          if(this.modalDataAttr.Error.del_day){
            this.$errorMsg(this.$I18n("illegal_param"))
          }
          if(this.modalDataAttr.Error.lifecycle){
            this.$errorMsg(this.$I18n("error_params_vertime"))
          }
          if(this.modalDataAttr.Error.alarm_inr){
            this.$errorMsg(this.$I18n("illegal_param"))
          }
          return
        }
        if(attrsForm.lifecycle){
          this.modalData.Form.attr = JSON.stringify({
            esoss_cfg: isNaN(attrsForm.esoss_cfg) ?0 :parseInt(attrsForm.esoss_cfg),
            lsoss_cfg: isNaN(attrsForm.lsoss_cfg) ?0 :parseInt(attrsForm.lsoss_cfg),
            vendor_id   : (isNaN(attrsForm.vendor_id) || attrsForm.vendor_id <= 0) ?1009 :parseInt(attrsForm.vendor_id),
            del_day  : parseInt(attrsForm.del_day),
            lifecycle   : parseInt(attrsForm.lifecycle),
            oss_cfg     : parseInt(attrsForm.oss_cfg),
            eventoss_cfg: parseInt(attrsForm.eventoss_cfg),
            alarm_inr   : parseInt(attrsForm.alarm_inr),
            dk_limit    : parseInt(attrsForm.dk_limit ?attrsForm.dk_limit :2),
            live        : parseInt(attrsForm.live ?attrsForm.live : 2),

            a_type      : parseInt(attrsForm.a_type ?attrsForm.a_type : 1),
            f_ioss      : parseInt(attrsForm.f_ioss ?attrsForm.f_ioss : 2),
          })
        } else {
          this.modalData.Form.attr = JSON.stringify({
            esoss_cfg: isNaN(attrsForm.esoss_cfg) ?0 :parseInt(attrsForm.esoss_cfg),
            lsoss_cfg: isNaN(attrsForm.lsoss_cfg) ?0 :parseInt(attrsForm.lsoss_cfg),
            vendor_id   : (isNaN(attrsForm.vendor_id) || attrsForm.vendor_id <= 0) ?1009 :parseInt(attrsForm.vendor_id),
            del_day  : parseInt(attrsForm.del_day),
            lifecycle: 1,
            alarm_inr: 120,
            dk_limit : 2,
            a_type      : parseInt(attrsForm.a_type ?attrsForm.a_type : 1),
            f_ioss      : parseInt(attrsForm.f_ioss ?attrsForm.f_ioss : 2),
          })
        }
        this.$api.addProduct(this.modalData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType == 'edit'){ 
        if(this.modalData.Check()){
          this.$errorMsg(this.$I18n("pls_check_verify"))
          return 
        }
        if(this.modalDataAttr.Check()){
          if(this.modalDataAttr.Error.del_day){
            this.$errorMsg(this.$I18n("illegal_param"))
          }
          if(this.modalDataAttr.Error.lifecycle){
            this.$errorMsg(this.$I18n("error_params_vertime"))
          }
          if(this.modalDataAttr.Error.alarm_inr){
            this.$errorMsg(this.$I18n("illegal_param"))
          }
          return
        }
        if(attrsForm.lifecycle){
          this.modalData.Form.attr = JSON.stringify({
            esoss_cfg: isNaN(attrsForm.esoss_cfg) ?0 :parseInt(attrsForm.esoss_cfg),
            lsoss_cfg: isNaN(attrsForm.lsoss_cfg) ?0 :parseInt(attrsForm.lsoss_cfg),
            vendor_id: (isNaN(attrsForm.vendor_id) || attrsForm.vendor_id <= 0) ?1009 :parseInt(attrsForm.vendor_id),
            del_day  : parseInt(attrsForm.del_day),
            lifecycle: parseInt(attrsForm.lifecycle),
            alarm_inr: parseInt(attrsForm.alarm_inr),
            oss_cfg  : parseInt(attrsForm.oss_cfg  ),
            eventoss_cfg:parseInt(attrsForm.eventoss_cfg),
            dk_limit : parseInt(attrsForm.dk_limit ?attrsForm.dk_limit :2),
            live     : parseInt(attrsForm.live ?attrsForm.live : 2),
            a_type      : parseInt(attrsForm.a_type ?attrsForm.a_type : 1),
            f_ioss      : parseInt(attrsForm.f_ioss ?attrsForm.f_ioss : 2),
          })
        } else {
          this.modalData.Form.attr = JSON.stringify({
            esoss_cfg: isNaN(attrsForm.esoss_cfg) ?0 :parseInt(attrsForm.esoss_cfg),
            lsoss_cfg: isNaN(attrsForm.lsoss_cfg) ?0 :parseInt(attrsForm.lsoss_cfg),
            vendor_id   : (isNaN(attrsForm.vendor_id) || attrsForm.vendor_id <= 0) ?1009 :parseInt(attrsForm.vendor_id),
            del_day  : parseInt(attrsForm.del_day),
            lifecycle: 1,
            alarm_inr: 120,
            dk_limit:  2,
            a_type      : parseInt(attrsForm.a_type ?attrsForm.a_type : 1),
            f_ioss      : parseInt(attrsForm.f_ioss ?attrsForm.f_ioss : 2),
          })
        }
        this.$api.editProduct(this.modalData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType == 'sub-add'){
        if(this.modalSubData.Check() || this.modalSubData.Form.details.some(i => !i.title || !i.url)){
          this.$errorMsg(this.$I18n("pls_check_verify"))
          return 
        }
        this.$api.addProductVer({
          ... this.modalSubData.Form,
          details: this.modalSubData.Form.details
            .map(i => ({
              ...i,
              zone: i.zone_type == 1 ?i.zone_continent :i.zone_zone,
            })),
          pk : this.selected.pk,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType == 'sub-edit'){
        if(this.modalSubData.Check() || this.modalSubData.Form.details.some(i => !i.title || !i.url)){
          this.$errorMsg(this.$I18n("pls_check_verify"))
          return 
        }
        this.$api.setProductVer({
          ...this.modalSubData.Form,
          details: this.modalSubData.Form.details
            .map(i => ({
              ...i,
              zone: i.zone_type == 1 ?i.zone_continent :i.zone_zone,
            })),
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if (this.openModalType == 'sub-delete') {
        this.$api.deleteProductVer(this.modalSubData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.modal_classicModalHide();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      }
    },
  },
  computed: {
    ver_tableData(){ // 表格-表格数据
      return [...this.ver_tableInitData]
        .splice((this.ver_pageNo-1) * this.pageSize, this.pageSize)
        .map(item => {
          // 版本更新方式
          let type_name = "";
          switch (item.type) {
            case 1:
              type_name = this.$I18n("user_select") 
              break;
            case 2:
              type_name = this.$I18n("force")
              break;
            default:
              type_name = this.$I18n("unknow_state")
              break;
          }
          // 版本等级
          let level_name = "";
          switch (item.level) {
            case 1:
              level_name = this.$I18n("low") 
              break;
            case 2:
              level_name = this.$I18n("center")
              break;
            default:
              level_name = this.$I18n("high")
              break;
          }
          // 版本状态
          let state_name = "";
          switch (item.state) {
            case 1:
              state_name = this.$I18n("open") 
              break;
            case 2:
              state_name = this.$I18n("close")
              break;
            default:
              state_name = this.$I18n("unknow_state")
              break;
          }
          // 版本关联类型
          let link_type_name = "";
          switch (item.link_type) {
            case 0:
              link_type_name = this.$I18n("none")
              break;
            case 1:
              link_type_name = "UID"
              break;
            case 2:
              link_type_name = "MAC"
              break;
            default:
              link_type_name = ""//this.$I18n("unknow_state")
              break;
          }
          return {
            ...item,
            level_name,
            type_name,
            state_name,
            link_type_name,
            create_thing_time: timestampToString(item.gmt_create * 1000),
            allow_time       : timestampToString(item.gmt_allow * 1000),
            update_time      : timestampToString(item.gmt_update * 1000),
          }
        })
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("icon"),
          keys    : "img",
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          }),
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("product_type"),
          keys    : "category",
          type    : "select",
          disabled: this.openModalType == 'edit',
          options : this.productType.map(i => {
            return {
              id  : i.id,
              name: this.$router.history.current.query.lang === "en" 
                ? i.name 
                : i.cn_name,
            }
          }),
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("node_type"),
          keys    : "node_type",
          type    : "radio",
          disabled: this.openModalType == 'edit',
          options : [
            {
              id  : 2,
              name: this.$I18n("device"),
            },{
              id  : 1,
              name: this.$I18n("gateway"),
            }
          ],
          help: this.$I18n("gateway_info"),
          class   : "md-layout-item md-size-66",
        // },{
        //   label   : this.$I18n("proto_type"),
        //   keys    : "proto_type",
        //   type    : "select",
        //   // dataType: "attr",
        //   hide    : this.UserInfo.role_id >= 10000,
        //   options : [
        //     {id:'udp', name:"UDP"},
        //     {id:'mqtt',name:"MQTT"},
        //   ],
        },{
          label   : this.$I18n("del_day"),
          keys    : "del_day",
          type    : "input",
          dataType: "attr",
          hide    : this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-33",
          check   : true,
        },{
          label   : this.$I18n("free_vali_time"),
          keys    : "lifecycle",
          type    : "input",
          dataType: "attr",
          hide    : this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("alarm_int"),
          keys    : "alarm_inr",
          type    : "input",
          dataType: "attr",
          hide    : this.UserInfo.role_id >= 10000,
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("alarm_cloud_storage"),
          keys    : "eventoss_cfg",
          type    : "select",
          dataType: "attr",
          options : [
            {id:2,name:"Aliyun"},
            {id:3,name:"AWS"},
            {id:4,name:"E2E"},
            {id:6,name:"Oracle"},
          ],
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("alarm_cloud_storage_ssl"),
          keys    : "esoss_cfg",
          type    : "select",
          dataType: "attr",
          options : [
            {id:2,name:"Aliyun"},
            {id:3,name:"AWS"},
            {id:4,name:"E2E"},
            {id:6,name:"Oracle"},
          ],
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("video_cloud_storage"),
          keys    : "oss_cfg",
          type    : "select",
          dataType: "attr",
          options : [
            {id:2,name:"Aliyun"},
            {id:3,name:"AWS"},
            {id:4,name:"E2E"},
            {id:6,name:"Oracle"},
          ],
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("video_cloud_storage_ssl"),
          keys    : "lsoss_cfg",
          type    : "select",
          dataType: "attr",
          options : [
            {id:2,name:"Aliyun"},
            {id:3,name:"AWS"},
            {id:4,name:"E2E"},
            {id:6,name:"Oracle"},
          ],
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("dk_limit"),
          keys    : "dk_limit",
          type    : "select",
          options : [
            {id:1,name:this.$I18n("open")},
            {id:2,name:this.$I18n("close")},
          ],
          dataType: "attr",
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("support_live"),
          keys    : "live",
          type    : "select",
          options : [
            {id:1,name:this.$I18n("support")},
            {id:2,name:this.$I18n("closed")},
          ],
          dataType: "attr",
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("vendor_id_key"),
          keys    : "vendor_id",
          type    : "input",
          // required: true,
          // check   : true,
          hide    : this.UserInfo.role_id >= 10000,
          dataType: "attr",
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("a_type"),
          keys    : "a_type",
          type    : "select",
          hide    : this.UserInfo.role_id >= 10000,
          dataType: "attr",
          options : [
            {id:1,name:this.$I18n("none")},
            {id:2,name:this.$I18n("uid_auth")},
          ],
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("f_ioss"),
          keys    : "f_ioss",
          type    : "select",
          hide    : this.UserInfo.role_id >= 10000,
          dataType: "attr",
          options : [
            {id:1,name:this.$I18n("support")},
            {id:2,name:this.$I18n("no_support")},
          ],
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("sync_state"),
          keys    : "sync",
          type    : "select",
          options : [
            {id:1,name:this.$I18n("synchronous")},
            {id:2,name:this.$I18n("asynchronous")},
          ],
          class   : "md-layout-item md-size-33",
        },{
          label   : this.$I18n("remarks"),
          keys    : "remark",
          type    : "textarea",
          class   : "md-layout-item md-size-100",
        }
      ]
    },
    form_modalSubData(){
      return [
        {
          label   : this.$I18n("force_update_select"),
          keys    : "type",
          type    : "select",
          options : [
            {
              id  : 1,
              name: this.$I18n("user_select"),
            },{
              id  : 2,
              name: this.$I18n("force"),
            }
          ],
          placeholder: this.$I18n('pls_select'),
        },{
          label   : this.$I18n("level"),
          keys    : "level",
          type    : "select",
          options : [
            {
              id  : 1,
              name: this.$I18n("low"),
            },{
              id  : 2,
              name: this.$I18n("center"),
            },{
              id  : 3,
              name: this.$I18n("high"),
            }
          ],
          required: true,
        },{
          label   : this.$I18n("ver_code"),
          keys    : "ver_num",
          type    : "input",
          required: true,
          check   : true,
          placeholder: "20010101",
        },{
          label   : this.$I18n("version"),
          keys    : "ver",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("min_ver_num"),
          keys    : "min_ver_num",
          type    : "input",
          placeholder: "20010101",
        },{
          label   : this.$I18n("max_ver_num"),
          keys    : "max_ver_num",
          type    : "input",
          placeholder: "20010101",
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          options : [
            {
              id  : 1,
              name: this.$I18n("open"),
            },{
              id  : 2,
              name: this.$I18n("close"),
            }
          ],
          required: true,
          check   : true,
        },{
          label   : this.$I18n("custom_key"),
          keys    : "oem",
          type    : "input",
          // required: true,
        },{
          label   : this.$I18n("batch_id"),
          keys    : "batch_id",
          type    : "input",
        },{
          label   : this.$I18n("link_type"),
          keys    : "link_type",
          type    : "select",
          options : [
            {
              id  : 0,
              name: this.$I18n("none"),
            },{
              id  : 1,
              name: "UID",
            },{
              id  : 2,
              name: "MAC",
            }
          ],
        },{
          label   : this.modalSubData.Form.link_type == 1 ?"UID" :"MAC",
          keys    : "link_id",
          type    : "input",
          hide    : this.modalSubData.Form.link_type == 0,
        },{
          label   : this.$I18n("issued_limit"),
          keys    : "limit",
          type    : "input",
        },{
          label   : this.$I18n("issued_count"),
          keys    : "count",
          type    : "input",
          disabled: true,
        },{
          label   : this.$I18n("tag"),
          keys    : "tag",
          type    : "input",
          required: true,
          check   : true,
          // disabled: true,
        }
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
  .md-layout-item .version {
    transition: all 0s;
  }
  .line{
    content: "";
    height: 1px;
    width: calc(100% - 15px);
    background-color: rgba(180, 180, 180, 0.3);
  }
  .sec-side{
    font-size: 16px;
    font-weight: 300;
    height: 70px;
    width: 200px;
    box-sizing: border-box;
    padding: 15px 12px;
    line-height: 40px;
  }
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    // width: calc( 100% - 15px );
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }

  .tabs-content{
    width : 200px;
    box-shadow : none;
    border-right : 1px solid #ddd;
    border-radius: 0;
    margin-right : 18px;
  }
  .product-card-img{
    position: absolute;
    z-index: -1;
    top      : 10px;
    bottom   : 10px;
    left     : 10px;
    max-width: 80%;
    opacity  : 1;
  }
  .product-card-img img{
    max-height:100%;
    max-width :100%;
    border-radius: 4px;
  }
  .product-card-img .shadow{
    position: absolute;
    top   : 0;
    left  : 0;
    right : 0;
    bottom: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 1));
  }
  .weight-font{
    margin-top: 5px;
    font-size: 18px;
    margin-bottom: 13px;
  }
  .product-card-p {
    background-color: #ccc;
    border: 2px solid #ffffff;
    display: inline;
    padding: 6px 12px;
    border-radius : 4px;
    font-weight: 400;
    margin-left: -2px;
  }
  .tabs-contant{
    padding-top : 40;
    width: calc(100% - 240px);
    box-shadow: none;
  }
  .left-table {
    text-align: left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    margin-right : 16px;
  }
  .card-form {
    margin-top: 0;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>
